import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/sonner';
import { BetaBanner } from '../BetaBanner';

export const MainLayout = () => {
  return (
    <div className="flex h-screen overflow-hidden" data-testid="main-layout">
      <Sidebar />
      <div className="flex-1 overflow-auto bg-background flex flex-col">
        <BetaBanner />
        <main className="p-8 flex-1">
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" />
    </div>
  );
};
